import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1d": "#CBAA6C",
    "col1l": "#F0D8AA",
    "col1n": "#E0BF81"
}
function AccHat169({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M228.5.7l-1.4.1Q126.25 5.5 45.1 0L19.7 18.85 42.2 87.3l-22.5 72.85Q12.6 180.25 0 196.7q.65-.45 1.3-.85 53.55-3.7 106.9-3.8 56.9-.15 113.6 3.8-8.35-15.55-11.65-35.7 5.85 15.8 17.1 30.5 2.75-4.45 11.6-16.55l-.6.65 6.25-7.25q-10.8-10.4-17.1-24.55l-15.1-53.8L228.5.7M22.2 187.15l-2.5.3q0-.05.05-.1l2.45-.2z"
                    id="AccHat169__Symbol_561_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1l}
                    d="M193.15 35.1q-1.95-20.55-2.7-35.1Q115.4 6.2 60.1 3.25 4.8.25 0 0q1.5 13.35 2.4 26.8 2 28.5 1.4 56.9-.4 19-1.95 38-.15 1.8-.3 3.55-.7 8-1.55 16.05 1.3.25 48.35-2.05 20.05-1 40.15-1.15 26.95-.25 53.95.95 47 2.1 48 2.25 0-.1-.2-4.1-.25-4 .5-18.05.7-14.1 2.5-38.8 1.8-24.75-.1-45.25z"
                    id="AccHat169__Symbol_562_0_Layer0_0_FILL"
                />
                <path
                    fill={colors.col1d}
                    d="M3.4 18.15Q2.15 31.5 1.35 44.95-.4 73.45.15 102q.4 20.75 1.95 41.4.55 7.9 1.3 15.85v.2l17.25-17.2-.1-1.3Q15.45 73.6 21.75 0l-10 9.95q.2-.05.4-.05L3.4 18.15z"
                    id="AccHat169__Symbol_563_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#AccHat169__Symbol_561_0_Layer0_0_FILL"
                transform="translate(71.25 53.45)"
                id="AccHat169__col1n"
            />
            <use
                xlinkHref="#AccHat169__Symbol_562_0_Layer0_0_FILL"
                transform="translate(90.95 72.3)"
                id="AccHat169__col1l"
            />
            <use
                xlinkHref="#AccHat169__Symbol_563_0_Layer0_0_FILL"
                transform="translate(278 54.15)"
                id="AccHat169__col1d"
            />
        </g></g>
    )
}
export default AccHat169
